<ng-container *ngIf="!isLoading && !hasError; else loadingOrError">
  <ng-container *ngIf="catalog; else noCatalog">

    <div class="inspect-header">
      <span class="inspect-header-title">{{ catalog?.catalogName || ('Katalog' | translate) }}</span>
    </div>

    <dx-tab-panel
      [animationEnabled]="true"
      [swipeEnabled]="false"
      iconPosition="start"
      stylingMode="primary"
      width="100%">

      <dxi-item [title]="'Import' | translate">
        <div *dxTemplate>
          <div class="inspect-content p-2">

            <div class="context-row">
              <div class="context-label">{{ 'Letzte Änderung' | translate }}</div>
              <div class="context-value">
                {{ container?.lastChanged ? (container.lastChanged | date:'short') : 'n/b' }}
              </div>
              <div class="context-actions"></div>
            </div>

            <div class="context-row">
              <div class="context-label">{{ 'Lieferant' | translate }}</div>
              <div class="context-value">{{ dataSource?.name || 'n/b' }}</div>
            </div>

            <div class="context-row">
              <div class="context-label">{{ 'Typ' | translate }}</div>
              <div class="context-value">{{ dataSource?.type || 'n/b' }}</div>
            </div>

            <div class="context-row">
              <div class="context-label">{{ 'Letzter importierter Katalog' | translate }}</div>
              <div class="context-value">n/b</div>
            </div>

            <div class="context-row">
              <div class="context-label">{{ 'Katalog-Anzahl' | translate }}</div>
              <div class="context-value">{{ container?.catalogIds?.length || 0 }}</div>
            </div>

            <div class="context-row">
              <div class="context-label">{{ 'Produkt-Anzahl' | translate }}</div>
              <div class="context-value">{{ container?.productCount || 0 }}</div>
            </div>

            <div class="context-row">
              <div class="context-label">🔴 {{ 'Gelöscht' | translate }}</div>
              <div class="context-value">0</div>
            </div>

            <div class="context-row">
              <div class="context-label">🟡 {{ 'Geändert' | translate }}</div>
              <div class="context-value">0</div>
            </div>

            <div class="context-row">
              <div class="context-label">🟢 {{ 'Neu' | translate }}</div>
              <div class="context-value">0</div>
            </div>

            <div class="context-row context-top">
              <div class="context-label">{{ 'Notizen' | translate }}</div>
              <div class="context-value context-pre">
                {{ container?.note || ('Kommentar hinzufügen…' | translate) }}
              </div>
            </div>

          </div>
        </div>
      </dxi-item>

      <dxi-item [title]="'Katalog' | translate">
        <div *dxTemplate>
          <div class="inspect-content p-2">

            <div class="section-title section-with-action">
              <span>{{ 'Katalog' | translate }}</span>
              <dx-button stylingMode="text" hint="{{ 'Katalog bearbeiten' | translate }}" type="default" (onClick)="openMetadataDialog()" icon="edit"></dx-button>
            </div>

            <div class="context-row">
              <div class="context-label">{{ 'Name' | translate }}</div>
              <div class="context-value">
                {{ catalog?.catalogName || '–' }}
              </div>
            </div>

            <div class="context-row">
              <div class="context-label">{{ 'Version' | translate }}</div>
              <div class="context-value">
                {{ catalog?.catalogVersion || '–' }}
              </div>
            </div>

            <div class="context-row">
              <div class="context-label">{{ 'Gruppierung' | translate }}</div>
              <div class="context-value">
                {{ catalog?.pimGroup || '–' }}
              </div>
            </div>

            <div class="context-row">
              <div class="context-label">{{ 'Katalog-ID' | translate }}</div>
              <div class="context-value">
                {{ catalog?.catalogId || catalogId || '–' }}
              </div>
            </div>

            <div class="context-row">
              <div class="context-label">{{ 'Masterkatalog' | translate }}</div>
              <div class="context-value">
                –
              </div>
            </div>

            <div class="context-row">
              <div class="context-label">{{ 'Katalogstatus' | translate }}</div>
              <div *ngIf="catalog?.catalogState?.length; else noStatus" class="context-value chips">
                <span *ngFor="let s of catalog!.catalogState" class="chip">{{ s }}</span>
              </div>
              <ng-template #noStatus>
                <div class="context-value">–</div>
              </ng-template>
            </div>

            <div class="context-row">
              <div class="context-label">{{ 'Währungen' | translate }}</div>
              <div *ngIf="catalog?.currency; else noCurrency" class="context-value chips">
                <span class="chip">{{ catalog?.currency }}</span>
              </div>
              <ng-template #noCurrency>
                <div class="context-value">–</div>
              </ng-template>
            </div>

            <div class="context-row context-wrap">
              <div class="context-label">{{ 'Länder' | translate }}</div>
              <div *ngIf="catalog?.territories?.length; else noCountries" class="context-value chips">
                <span *ngFor="let t of catalog!.territories" class="chip">{{ t }}</span>
              </div>
              <ng-template #noCountries>
                <div class="context-value">–</div>
              </ng-template>
            </div>

            <div class="context-row">
              <div class="context-label">{{ 'Sprache' | translate }}</div>
              <div class="context-value">
                {{ catalog?.language || '–' }}
              </div>
            </div>

            <div class="section-title mt-3">
              {{ 'Rahmenvertrag' | translate }}
            </div>

            <div class="context-row">
              <div class="context-label">{{ 'Vertrags ID' | translate }}</div>
              <div class="context-value">
                {{ catalog?.agreement?.agreementId || '–' }}
              </div>
            </div>

            <div class="context-row">
              <div class="context-label">{{ 'Vertragstyp' | translate }}</div>
              <div class="context-value">
                {{ catalog?.agreement?.type || '–' }}
              </div>
            </div>

            <div class="context-row">
              <div class="context-label">{{ 'Beschreibung' | translate }}</div>
              <div class="context-value">
                {{ catalog?.agreement?.agreementDesc || '–' }}
              </div>
            </div>

            <div class="context-row">
              <div class="context-label">{{ 'Startzeit' | translate }}</div>
              <div class="context-value">
                {{ catalog?.agreement?.startDate ? (catalog.agreement.startDate | date:'shortDate') : '–' }}
              </div>
            </div>

            <div class="context-row">
              <div class="context-label">{{ 'Ende' | translate }}</div>
              <div class="context-value">
                {{ catalog?.agreement?.endDate ? (catalog.agreement.endDate | date:'shortDate') : '–' }}
              </div>
            </div>
          </div>

          <np-container-catalog-edit
            [(visible)]="editVisible"
            [catalog]="catalog"
            [popupTitle]="'Katalog bearbeiten' | translate"
            (saved)="onMetadataSaved($event)"
            (canceled)="onMetadataCanceled()">
          </np-container-catalog-edit>

        </div>
      </dxi-item>

      <dxi-item [title]="'Datenqualität' | translate">
        <div *dxTemplate>
          <div class="inspect-content p-2">
            <div class="section-title section-with-action">
              <span>{{ 'Datenqualität' | translate }}</span>
            </div>
          </div>
        </div>
      </dxi-item>

      <dxi-item [title]="'Medien' | translate">
        <div *dxTemplate>
          <div class="media-tab-content">
            <mediaPool *ngIf="catalog"></mediaPool>
          </div>
        </div>
      </dxi-item>

    </dx-tab-panel>
  </ng-container>
</ng-container>

<ng-template #loadingOrError>
  <div class="p-3 text-muted" *ngIf="isLoading">
    {{ 'Lade Katalog …' | translate }}
  </div>
  <div class="p-3 text-danger" *ngIf="!isLoading && hasError">
    {{ 'Katalog konnte nicht geladen werden.' | translate }}
  </div>
</ng-template>

<ng-template #noCatalog>
  <div class="p-3 text-muted">
    {{ 'Kein Katalog ausgewählt.' | translate }}
  </div>
</ng-template>
